import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import ChatForm from "~/chat/vue/widget/form/ChatForm.vue";
import Dictionary from "~/ts/library/Dictionary";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {WidgetStore} from "~/chat/ts/store/Widget";
import AnalyticCounters from "~/chat/ts/service/AnalyticCounters";
import ApiCallback, {API_CALLBACK_ADDITIONAL_FORM_SENDED} from "~/chat/ts/service/api/methods/ApiCallback";
import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import MessageStorage from "~/chat/ts/service/messages/MessageStorage";
import {useTabContentProps} from "~/chat/vue/widget/tabs/useTabContent";
import {getCurrentInstance, ref} from "vue";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "FormContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useTabContentProps()
},
  setup(__props) {

let props = __props;

let value = ref<Dictionary<any>>();
let disableSend = ref(false);
let instance = getCurrentInstance().proxy;

function selectChatTab() {
    if (WidgetStore.currentTab.value == props.tab) {
        WidgetStore.selectChatTab();
    }
}

async function send() {
    disableSend.value = true;
    let tab = props.tab;

    let p = {
        ...value.value,
        tabID: tab.id,
        currentPage: {
            url: window.location.href,
            title: document.title
        }
    };

    let result = await ChatApiRequest.make({
        method: "sendForm",
        p: p
    });

    disableSend.value = false;

    if (!result.isSuccess() || props.tab.content.showSuccessMessage) {
        WidgetStore.showModalMessage({
            text: result.getDescr(),
            escape: false,
            title: __("SYSTEM_MESSAGE"),
            bbcode: true,
            vue: instance,
            onClose: () => {
                if (result.isSuccess()) {
                    selectChatTab();
                }
            }
        });
    }
    if (result.isSuccess()) {
        let label = __("EVENT_SEND_FORM", tab.title);
        AnalyticCounters.send("Form submited", label, `Form submited ${tab.id}`);
        ApiCallback.emit(API_CALLBACK_ADDITIONAL_FORM_SENDED, p);
        MessageStorage.removeByTabId(tab.id);
        if (!props.tab.content.showSuccessMessage) {
            selectChatTab();
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.tab.content.html && _ctx.tab.content.html.length)
      ? (_openBlock(), _createBlock(Htmlify, {
          key: 0,
          escape: false,
          value: _ctx.tab.content.html,
          class: "mb-8",
          tag: "div"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    _createVNode(ChatForm, {
      form: _ctx.tab.content.form,
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : value = $event)),
      "show-load": _unref(disableSend),
      button: _ctx.tab.content.button,
      onApply: send,
      step: !!_ctx.tab.stepped,
      "stepped-card-display": false,
      "button-color": _ctx.tab.formButtonColor
    }, null, 8, ["form", "modelValue", "show-load", "button", "step", "button-color"]),
    (_ctx.tab.content.html_footer && _ctx.tab.content.html_footer.length)
      ? (_openBlock(), _createBlock(Htmlify, {
          key: 1,
          escape: false,
          value: _ctx.tab.content.html_footer,
          class: "mt-8",
          tag: "div"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})